/**
 * Display helpers for Review Summary title line + unified risk pill (FR-005a–b).
 * Never invents a denominator when the API does not provide one.
 */

/** Primary numeric text inside the pill (e.g. "3" or "1/3"). */
export const formatPillPrimaryCount = (current: number, total: number | null | undefined): string => {
  if (total != null && total > 0) {
    const safe = Math.max(0, Math.min(Math.floor(current), Math.floor(total)));
    return `${safe}/${Math.floor(total)}`;
  }
  return String(Math.max(0, Math.floor(current)));
};
